// libraries
import React from 'react';
import styled from 'styled-components';

import { Flex, PrimaryButton } from 'shared/styledComponents';
import { H3, Text } from 'shared/typography';

import devices from 'theme/devices';
// assets
import adElement from 'assets/images/ad-element.png';
import adElementMobile from 'assets/images/ad-element-mobile.png';

import { useIsAllowedSlug } from './useIsAllowedSlug';

const AdContainer = styled(Flex)<any>(
  ({ isComponentShown, theme }) => `
display: ${isComponentShown ? 'flex;' : 'none;'}
height: 150px;
background-color: ${theme.colors.secondary};
margin-bottom: 30px;
@media ${devices.mobile} {
  flex-direction: column;
  height: auto;
  padding: 20px;
  align-items: center;
}
  `,
);

const ImageDesktop = styled.img`
  object-fit: contain;
  flex: 1;
  height: 100%;
  object-position: left;
  align-self: flex-end;

  @media ${devices.mobile} {
    display: none;
  }
`;

const ImageMobile = styled.img`
  display: none;
  @media ${devices.mobile} {
    display: block;
  }
`;

const AdContentContainer = styled(Flex)`
  flex: 5;
  align-items: center;
  justify-content: space-between;
  padding-right: 30px;

  @media ${devices.mobile} {
    flex-direction: column;
    padding-right: 0px;
  }
`;

const AdTitle = styled(H3)`
  font-size: 26px;
  @media ${devices.mobile} {
    font-size: 22px;
  }
`;

const AdText = styled(Text)`
  @media ${devices.mobile} {
    font-size: 14px;
    margin-bottom: 8px;
  }
  br {
    @media ${devices.mobile} {
      display: none;
    }
  }
`;

const Link = styled.a`
  white-space: nowrap;
`;

const ParentbirthContentAd = (): JSX.Element => {
  return (
    <AdContainer isComponentShown={useIsAllowedSlug()}>
      <ImageDesktop src={adElement} />
      <ImageMobile src={adElementMobile} />
      <AdContentContainer>
        <div>
          <AdTitle>Your Virtual Doula has arrived!</AdTitle>
          <AdText>
            Expecting & new parents can now text with experts <br />
            for FREE to ask questions about pregnancy, birth, postpartum and new parenthood.
          </AdText>
        </div>
        <Link target="_blank" href={'http://parentbirth.com/'}>
          <PrimaryButton>Learn More</PrimaryButton>
        </Link>
      </AdContentContainer>
    </AdContainer>
  );
};

export default ParentbirthContentAd;
